import styled from 'styled-components'

import { mediaPrintRemoveMargPaddBackg, tableCss } from '../../styles'

const WrapSectionDetail = styled.div`
  #title {
    text-decoration-line: underline;
  }
  #header {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #value {
    font-weight: 100;
  }
`

const WrapSpacer = styled.div`
  padding-bottom: 20px;
`

const WrapTableDiv = styled.div`
  ${mediaPrintRemoveMargPaddBackg}
  ${tableCss}
`

export { WrapSectionDetail, WrapSpacer, WrapTableDiv }
